import { PriorityHigh } from "@mui/icons-material";
import { Box, LinearProgress } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import FullScreenMessageCore from "../../../components/fullScreenMessage/FullScreenMessageCore";
import NotFoundFullScreenMessage from "../../../components/fullScreenMessage/NotFoundFullScreenMessage";
import { PETS_APPOINTMENTS } from "../../../enums/QueryKeys";
import { PET_DETAILS_ } from "../../../enums/UrlPaths";
import { useFetch } from "../../../hooks/Fetching";
import useUser from "../../../hooks/useUser";
import { PetAppointmentsTab } from "../../appointments/components/tabs/components/AppointmentsTabs";
import { APPOINTMENTS } from "../enums/TabsRequestParams";

export default function PetsAppointments() {
  const { id: petId } = useParams();
  const { roles } = useUser();
  const navigate = useNavigate();
  const url = PET_DETAILS_ + petId + "?tab=" + APPOINTMENTS;
  const { data, isLoading, error } = useFetch(
    url,
    null,
    PETS_APPOINTMENTS + petId
  );
  if (isLoading) {
    return <LinearProgress />;
  }

  if (error) {
    if (
      error?.response?.status === 403 ||
      String(error?.response?.data).toUpperCase() === String("FORBIDDEN")
    ) {
      navigate(-1);
      return;
    }
    return <NotFoundFullScreenMessage />;
  }

  if (!data?.speciesAllowed && !roles.adminOrEmployee && !roles.master) {
    return (
      <Box>
        <FullScreenMessageCore
          centerRelative={true}
          icon={<PriorityHigh className="Mui-fullscreen-icon" />}
          title={"PetNotAllowedInThisClinicUserMessage"}
        />
      </Box>
    );
  }
  return (
    <Box>
      <PetAppointmentsTab isDeceased={data.deceased} isOwnerDeleted={data.ownerDeleted} />
    </Box>
  );
}
